import { writable } from "svelte/store";

export type DocDescriptor = {
    [key: string]: Array<any> | object;
}
type Initials = {initials:string, enabled?:boolean, uid: string}



export function userStore() {
    const store = writable<{ users: Record<string, Initials>}>({ users: {} }); // Replace with your SSE endpoint
    const source = new EventSource('https://inits.val.run/');

    source.onmessage = function (msg: any) {
        const user = JSON.parse(msg.data) as Initials;
        store.update((currentState) => {
            const newState = { ...currentState };
            newState.users[user.uid] = user;
            return newState;
        });
    }

    return { store }
}


